import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';

function AppFooter() {
  const { t } = useTranslation();
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  function goTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  // Split copyright text by newlines to render properly
  const copyrightLines = t('copyright').split('\n');

  return (
    <Container fluid>
      <div className="copyright">
        {copyrightLines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < copyrightLines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
      <div className="socials">
        <ul>
          <li><a href="https://www.facebook.com" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a></li>
          <li><a href="https://www.twitter.com" aria-label="Twitter"><i className="fab fa-twitter"></i></a></li>
          <li><a href="https://www.linkedin.com/company/tensor-engineering-services-llc" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a></li>
        </ul>
      </div>
      {
        showTopBtn && (
          <div className="go-top" onClick={goTop} aria-label={t('goToTop')}></div>
        )
      }
    </Container>
  )
}

export default AppFooter;
